import { electronicFormatIBAN, isValidIBAN } from "ibantools";
/** Shared, isomorphic validation message used by both client and server. */
export const INVALID_IBAN_MESSAGE = "Die eingegebene IBAN ist ungültig. Bitte überprüfe die Eingabe.";
/** Strip spaces/dashes and uppercase — formatting only, does not validate. */
export function stripIbanFormatting(raw) {
    return electronicFormatIBAN(raw) ?? raw.replace(/[\s-]/g, "").toUpperCase();
}
export function isValidIban(raw) {
    return !!raw && isValidIBAN(stripIbanFormatting(raw));
}
//# sourceMappingURL=iban.js.map